/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：663
 */

module.exports = "https://creation.codemao.cn/coconut/web/1.22.0-0/" + "static/media/internet.8da56d4e.svg"
